"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _dataCapsule = require("data-capsule");
var _workerStrategy = _interopRequireDefault(require("./workerStrategy.js"));
var _consts = require("./applications/consts.js");
var _utils = require("./utils/utils");
var _httpClient = require("@wix/http-client");
var _cartItemsStatuses = _interopRequireDefault(require("wix-art-store-3rd-party/dist/src/sdk/cartItemsStatuses"));
var _photographyClientLib = require("@wix/photography-client-lib");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
var httpClient = new _httpClient.HttpClient();
var CartApi = /*#__PURE__*/function () {
  function CartApi(namespace, instance) {
    this.namespace = namespace;
    this.instance = instance;
    // if (utils.isDev()) {
    var strategy = new _workerStrategy["default"]();
    this.dataStorage = new _dataCapsule.DataCapsule({
      strategy: strategy,
      namespace: namespace
    });
  }
  var _proto = CartApi.prototype;
  _proto.addToCart = function addToCart(uuid, mediaUrl, galleryId, providerId, quantity, isDemo, metadata, styleId) {
    var _this = this;
    var newItem = {
      uuid: uuid,
      mediaUrl: mediaUrl,
      galleryId: galleryId,
      providerId: providerId,
      quantity: quantity,
      isDemo: isDemo,
      metadata: metadata,
      styleId: styleId,
      status: _cartItemsStatuses["default"].OK,
      timestamp: new Date().getTime()
    };
    return this.setItem(uuid, newItem).then(function () {
      _this.notifyCartChange();
      return Promise.resolve(newItem);
    });
  };
  _proto.updateItemsValidation = /*#__PURE__*/function () {
    var _updateItemsValidation = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(arrItems, url) {
      var isNonEmptyArray, uniqueIdsToCheck, invalidItems;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (url === void 0) {
              url = undefined;
            }
            isNonEmptyArray = this._isNonEmptyArray(arrItems);
            if (!isNonEmptyArray) {
              _context.next = 10;
              break;
            }
            uniqueIdsToCheck = this.getItemsUniqueIds(arrItems);
            if (!this._isNonEmptyArray(uniqueIdsToCheck)) {
              _context.next = 10;
              break;
            }
            _context.next = 7;
            return this.getInvalidItemsForDownload(url, uniqueIdsToCheck);
          case 7:
            invalidItems = _context.sent;
            this.setInvalidItemsForDownload(invalidItems, arrItems);
            return _context.abrupt("return", Promise.resolve());
          case 10:
            return _context.abrupt("return", Promise.reject("No ids to check for invalid cart items"));
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function updateItemsValidation(_x, _x2) {
      return _updateItemsValidation.apply(this, arguments);
    }
    return updateItemsValidation;
  }();
  _proto.removeFromCart = function removeFromCart(uuid) {
    var _this2 = this;
    return this.dataStorage.removeItem(uuid).then(function () {
      _this2.notifyCartChange();
    });
  };
  _proto.notifyCartChange = function notifyCartChange() {
    if (_photographyClientLib.window.Wix) {
      _photographyClientLib.Wix.PubSub.publish(_consts.ARTSTORE_PUBSUB_ENUMS.REFRESH_CART, {}, true);
    }
  };
  _proto.clearCart = function clearCart() {
    var _this3 = this;
    if (_utils.utils.isStoreGallery()) {
      return this.getCartItems('*').then(function (arrItems) {
        var arrPromises = [];
        arrItems.forEach(function (item) {
          var uuid = item.uuid;
          arrPromises.push(_this3.dataStorage.removeItem(uuid));
        });
        return Promise.all(arrPromises);
      }).then(function () {
        _this3.notifyCartChange();
      });
    }
  };
  _proto.setItem = function setItem(uuid, item, expiration /* 24 hours */) {
    if (expiration === void 0) {
      expiration = 86400;
    }
    return this.dataStorage.setItem(uuid, item, {
      expiration: expiration
    });
  };
  _proto.updateCartItem = function updateCartItem(uuid, metadata, quantity) {
    var _this4 = this;
    return this.dataStorage.getItem(uuid).then(function (cartItem) {
      var returnPromise = null;
      if (cartItem) {
        cartItem.metadata = metadata || cartItem.metadata;
        cartItem.quantity = quantity || cartItem.quantity;
        returnPromise = _this4.setItem(uuid, cartItem).then(function () {
          _this4.notifyCartChange();
        });
      } else {
        returnPromise = Promise.reject('Item not found');
      }
      return returnPromise;
    });
  };
  _proto.getCartItemsCount = function getCartItemsCount(arrItems) {
    var count = arrItems.reduce(function (previousCount, cartItem) {
      return previousCount + cartItem.quantity;
    }, 0);
    return count;
  };
  _proto.getCartItems = function getCartItems(connectedProviderId, options) {
    if (options === void 0) {
      options = {};
    }
    if (!connectedProviderId) {
      var message = "Can't get cart items without providerId";
      console.error(message);
      throw message;
    }
    try {
      return this.dataStorage.getAllItems().then(function (objCartItems) {
        var cartItems = [];
        var itemUUID = options.uuid;
        // eslint-disable-next-line guard-for-in
        for (var cartItemUuid in objCartItems) {
          var cartItemCandidate = objCartItems[cartItemUuid];
          var uuid = cartItemCandidate.uuid,
            providerId = cartItemCandidate.providerId;
          var isUUIDValid = !itemUUID || itemUUID === uuid;
          var isSameProviderId = !connectedProviderId || connectedProviderId === providerId || connectedProviderId === '*';
          var shouldAddItem = isUUIDValid && isSameProviderId;
          if (shouldAddItem) {
            var cartItem = objCartItems[uuid];
            cartItems.push(cartItem);
          }
        }
        return cartItems.sort(function (item1, item2) {
          var item1Timestamp = item1.timestamp || 0;
          var item2Timestamp = item2.timestamp || 0;
          return item1Timestamp - item2Timestamp;
        });
      });
    } catch (error) {
      console.error('CartApi - getCartItems - ERROR:', error);
    }
  };
  _proto.containsDemoItems = function containsDemoItems(connectedProviderId) {
    return this.getCartItems(connectedProviderId).then(function (items) {
      return items.filter(function (item) {
        return item.isDemo;
      });
    }).then(function (demoItems) {
      return demoItems.length > 0;
    });
  };
  _proto.countCartForms = function countCartForms() {
    var cartFormCount = 0;
    for (var i = 0; i < _photographyClientLib.window.top.frames.length; i++) {
      var frame = _photographyClientLib.window.top.frames[i];
      try {
        if (frame.location.href.indexOf('cart-form') !== -1) {
          cartFormCount++;
        }
      } catch (e) {}
    }
    return cartFormCount;
  };
  _proto.createCartForm = function createCartForm() {
    if (_utils.utils.isStoreGallery()) {
      var cartFormCount = this.countCartForms();
      if (!cartFormCount) {
        if (_photographyClientLib.Wix.Utils.getViewMode() === 'site' || _photographyClientLib.Wix.Utils.getViewMode() === 'preview') {
          _photographyClientLib.Wix.openPersistentPopup({
            url: _photographyClientLib.window.location.origin + '/cart-form.html?isStore=true',
            width: '0%',
            height: '100%',
            position: {
              origin: _photographyClientLib.Wix.WindowOrigin.FIXED,
              placement: _photographyClientLib.Wix.WindowPlacement.CENTER
            },
            theme: _photographyClientLib.Wix.Theme.BARE
          });
        }
      }
    }
  };
  _proto.showCart = function showCart() {
    _photographyClientLib.Wix.PubSub.publish('showCart', {}, false);
    _photographyClientLib.Wix.PubSub.publish(_consts.ARTSTORE_PUBSUB_ENUMS.SHOW_OOI_CART, {}, false);
  };
  _proto.hideCart = function hideCart(data) {
    _photographyClientLib.Wix.PubSub.publish('closeCartForm', {
      data: data
    }, false);
  };
  _proto.publishAddToCart = function publishAddToCart(dataToSend) {
    _photographyClientLib.Wix.PubSub.publish('ADD_TO_CART', dataToSend, true);
  };
  _proto._isNonEmptyArray = function _isNonEmptyArray(arr) {
    return arr && Array.isArray(arr) && arr.length;
  };
  _proto._setInvalidItems = function _setInvalidItems(arrInvalidItems) {
    var _this5 = this;
    if (this._isNonEmptyArray(arrInvalidItems)) {
      var invalidPromises = [];
      arrInvalidItems.forEach(function (invalidItem) {
        var item = invalidItem.item,
          reason = invalidItem.reason;
        invalidPromises.push(_this5.setItem(item.uuid, Object.assign({}, item, {
          status: reason
        })));
      });
      return Promise.all(invalidPromises).then(function () {
        _this5.notifyCartChange();
      });
    }
  };
  _proto.getInvalidItemsForDownload = /*#__PURE__*/function () {
    var _getInvalidItemsForDownload = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(url, uniqueIdsToCheck) {
      var defaultUrl, _url, payload, response, invalidItems;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            defaultUrl = "_api/pro-gallery-webapp/v1/items/verification?instance=" + this.instance;
            _url = url || defaultUrl;
            payload = url ? {
              uniqueIdsToCheck: uniqueIdsToCheck
            } : {
              mediaUrls: uniqueIdsToCheck
            };
            if (!this._isNonEmptyArray(uniqueIdsToCheck)) {
              _context2.next = 9;
              break;
            }
            _context2.next = 6;
            return httpClient.post(_url, payload, {
              headers: {
                'content-type': 'application/json'
              }
            });
          case 6:
            response = _context2.sent;
            invalidItems = response.data.invalidItems;
            return _context2.abrupt("return", invalidItems);
          case 9:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    function getInvalidItemsForDownload(_x3, _x4) {
      return _getInvalidItemsForDownload.apply(this, arguments);
    }
    return getInvalidItemsForDownload;
  }();
  _proto.setInvalidItemsForDownload = function setInvalidItemsForDownload(invalidItems, items) {
    var _this6 = this;
    if (this._isNonEmptyArray(invalidItems)) {
      invalidItems.forEach(function (invalidItem) {
        var mediaUrl = invalidItem.mediaUrl,
          err = invalidItem.err;
        var arrInvalidCartItems = items.filter(function (cartItem) {
          return cartItem.mediaUrl === mediaUrl;
        });
        var result = [].concat(arrInvalidCartItems.map(function (item) {
          return {
            item: item,
            reason: err || _cartItemsStatuses["default"].INVALID
          };
        }));
        _this6._setInvalidItems(result);
      });
    }
  };
  _proto.getItemsUniqueIds = function getItemsUniqueIds(items) {
    return items.reduce(function (previousValue, currentValue) {
      var mediaUrl = currentValue.mediaUrl;
      if (mediaUrl && previousValue.indexOf(mediaUrl) === -1) {
        previousValue.push(mediaUrl);
      }
      return previousValue;
    }, []);
  };
  return CartApi;
}();
var domain = '';
var instance = _photographyClientLib.window.instance;
if (_photographyClientLib.window.instanceId) {
  domain = _photographyClientLib.window.instanceId;
} else {
  try {
    if (_photographyClientLib.window.Wix) {
      domain = _photographyClientLib.Wix.Utils.getInstanceId();
    } else {
      // We're in a test
      domain = 'test';
    }
  } catch (error) {
    console.log("error domain", error);
  }
}
var cartApi = new CartApi(domain, instance);
var _default = exports["default"] = cartApi;
if (process.env.NODE_ENV === 'development') {
  _photographyClientLib.window.galleryApi = _photographyClientLib.window.galleryApi || {};
  _photographyClientLib.window.galleryApi.cartApi = cartApi;
}